import {client} from './services/client'

export  const tiers = {
    namespaced:true,
    state:{
        tiers:[],
    },
    mutations: {
        SET_TIER (state,tiers){
            state.tiers = tiers
        },

    },
    actions: {
        getTier({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers/get',
                })
                    .then((response)=>{
                        let tiers = response.data.tiers;
                        console.log(tiers);
                        commit('SET_TIER',tiers)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setTier({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/tiers/save',
                    data:data,
                })
                    .then((response)=>{
                        let tiers = response.data.tiers;
                        commit('SET_TIER',tiers);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteTier({commit},id){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/tiers/delete/'+id,
                })
                    .then((response)=>{
                        let tiers = response.data.tiers;
                        commit('SET_TIER',tiers);
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getTier: state  => {
            return state.tiers
        },
    }
};
